import React, { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { AppRemixIcon } from '@/layout/AppComponents';
import Select from 'react-select';
import ReactDOMServer from 'react-dom/server';
import styled from 'styled-components';
import colors from '../../../../constants/colors';
import { axiosPath } from '../../../../routing/helpers/router';
import * as currentPageAction from '../../../../store/actions/currentPageAction';
import Translator from '../../../components/helpers/Translator';
import useIsMounted from '../../../components/hooks/useIsMounted';
import ObligationFormQuestionHelp from '../ObligationFormQuestionHelp';
import errorHandler from '../../../components/error/ErrorHandler';
import QuestionChatbot from '../QuestionChatbot';

export default function QuestionType1(props) {
  const { question, isSubquestion } = props;
  const { moduleBridgeHex, plantHex } = useParams();
  const isMounted = useIsMounted();
  const dispatch = useDispatch();
  const questionUserAnswers = useSelector(
    (state) => state.currentPage?.answers?.[question.id]
  );
  const pendingQuestions = useSelector(
    (state) => state.currentPage?.pendingQuestions
  );
  const permissions = useSelector((state) => state.auth.permissions);
  const [isLoading, setIsLoading] = useState(false);
  const [tempAnswers, setTempAnswers] = useState(
    questionUserAnswers ||
      (question?.initialSelectedAnswerIDs
        ? question?.answers?.find(
            (a) => a.value === question?.initialSelectedAnswerIDs?.[0]
          )
        : null)
  );

  useEffect(() => {
    setTempAnswers(
      questionUserAnswers ||
        (question?.initialSelectedAnswerIDs
          ? question?.answers?.find(
              (a) => a.value === question?.initialSelectedAnswerIDs?.[0]
            )
          : null)
    );
  }, [question, questionUserAnswers]);

  // > QUESTION CHANGE
  const loadPlantObligationForm = useCallback(
    async (answer) => {
      setIsLoading(true);
      axios
        .post(
          axiosPath(
            "api_r_user_m_legalCompliance_plantObligationForm_question_change"
          ),
          {
            type: 1,
            moduleBridgeHex,
            plantHex,
            questionID: question.id,
            answerID: answer.value,
          }
        )
        .then((r) => {
          if (isMounted.current) {
            dispatch(
              currentPageAction.change("answers", r.data?.userAnswers, true)
            );
            dispatch(
              currentPageAction.change(
                "pendingQuestions",
                r.data.pendingQuestions,
                true
              )
            );
            setIsLoading(false);
          }
        })
        .catch((e) => {
          dispatch(errorHandler(e));
        });
    },
    [moduleBridgeHex, plantHex, question]
  );
  // < QUESTION CHANGE

  return (
    <QuestionGroup>
      <Question $isSubquestion={isSubquestion}>
        <h3>
          {permissions?.client?.gcl?.module?.plant?.userObligationForm
            ?.aiAssistant && <QuestionChatbot question={question} />}
          <AppRemixIcon
            icon="timer-2"
            color={
              pendingQuestions?.includes(question.id)
                ? colors.state2
                : colors.grey200
            }
            filled={pendingQuestions?.includes(question.id)}
            title={
              pendingQuestions?.includes(question.id)
                ? ReactDOMServer.renderToString(
                    <Translator
                      file="module-legalCompliance"
                      name="to.be.calculated"
                    />
                  )
                : ''
            }
            className="mr-1"
          />
         
          {question.name}
        </h3>
        <Select
          title={ReactDOMServer.renderToString(
            <Translator file="module-legalCompliance" name="example" />
          )}
          options={question.answers}
          onChange={loadPlantObligationForm}
          value={tempAnswers || null}
          isDisabled={isLoading}
          isLoading={isLoading}
        />
      </Question>
      <ObligationFormQuestionHelp question={question} />
    </QuestionGroup>
  );
}

const Question = styled.div`
  margin: 20px 0;
  ${(props) => props.$isSubquestion && 'padding-left: 40px;'}
  h3 {
    margin: 0;
    padding: 0;
    font-size: 16px;
    font-weight: bold;
    display: flex;
    align-items: center;
  }
`;
const QuestionGroup = styled.div`
  display: grid;
  grid-template-columns: 1fr 30px;
`;